/*jshint esversion: 6 */
import {
    addActionClass,
    addErrorClass,
    addLoadingClass,
    addSuccessClass,
    removeLoadingClass
} from "./utilities/updateClasses";
import {itemcardSubscriptions} from "./subscriptions";
import {hideIconbarHover, initIconbarHoverClose, showIconbarHover} from "./iconbarHover";
import {initCustomSelects} from "./customSelect";
import {initToggleSlide} from "./toggle";
import {XhrService} from "../ts/xhr.service";
import {appendScriptToDOM} from "./utilities/functions";
import {initFormSubmitChanges} from "./actionClick";
import {showModal} from "./modal";
import {closeModal} from "./modal";
import {initInputBody} from "./inputfile";
import {focusInputGroups} from "./checkInputGroups";
import {updateItemlistStickyOrderBarCount} from "./itemlistStickyOrderBar";
import {getAllQuantityInputs} from "./quantitySpinner";
import {initButtonsForIndividualization} from "./individualization";
import {announceToScreenReader} from "./utilities/announceToScreenReader";

function updateBasketCount(doc) {
    for (let basketCount of document.querySelectorAll('.js-basketCount')) {
        let firstNewBasketCount = doc.querySelector('.js-basketCount');
        if (firstNewBasketCount) {
            let count = parseInt(firstNewBasketCount.innerText);
            if (isNaN(count)) {
                count = 0;
            }
            if (count === 0) {
                basketCount.style.display = "none";
            } else {
                addActionClass(basketCount, function () {
                    basketCount.style.display = "";
                });
            }
        }
    }
}

function updateItem(target, doc) {
    let dataItemNo = target.dataset.itemNo;
    if (dataItemNo) {
        let addOn = target.closest(".js-updateItem");
        if (addOn) {
            let newTarget = doc.querySelector('.js-addListItemToBasket[data-item-no="' + dataItemNo + '"]');
            if (newTarget) {
                let newaddOn = newTarget.closest('.js-updateItem');
                if (newaddOn) {
                    addOn.innerHTML = newaddOn.innerHTML;
                } else {
                    console.error("cannot update orderbutton");
                }
            }
        }
    }
}

function updateOrderButtonItemcard(doc) {
    let itemcardBuybox = document.querySelector(".itemcardBuybox");
    let newItemcardBuybox = doc.querySelector('.itemcardBuybox');

    if (itemcardBuybox) {
        itemcardBuybox.innerHTML = newItemcardBuybox.innerHTML;

        itemcardSubscriptions(itemcardBuybox);
        initCustomSelects(itemcardBuybox.querySelectorAll(".js-customSelect"));
    }
}

export function updateHeaderBasket(doc) {
    let delayBasketHover = 6000;
    if(GLOBALS){
        if(GLOBALS.delayHideBasketHover){
            delayBasketHover = GLOBALS.delayHideBasketHover;
        }
    }
    for (let headerBasket of document.querySelectorAll('.js-headerBasket')) {
        let newHeaderBasket = doc.querySelector('.js-headerBasket');
        if (newHeaderBasket) {
            headerBasket.innerHTML = newHeaderBasket.innerHTML;
            headerBasket.classList.add("showIconbarHover");
            showIconbarHover(headerBasket);
            initIconbarHoverClose(headerBasket.querySelectorAll(".iconbarHover__close"));
            let basketCount = headerBasket.querySelector('.js-basketCount');

            if (basketCount) {
                addActionClass(basketCount);
            }

            // Focus management for accessibility - focus the basket hover overlay
            const iconbarHover = headerBasket.querySelector('.iconbarHover');
            if (iconbarHover) {
                if (!iconbarHover.hasAttribute('tabindex')) {
                    iconbarHover.setAttribute('tabindex', '-1');
                }
                setTimeout(() => {
                    iconbarHover.focus();

                    // Remove focus after a short delay to allow screen readers to announce
                    // but prevent the overlay from staying open indefinitely
                    setTimeout(() => {
                        if (document.activeElement === iconbarHover) {
                            iconbarHover.blur();
                        }
                    }, 1000);
                }, 100);
            }

            setTimeout(function () {
                // Only hide if the basket overlay or its children are not focused (accessibility)
                // This allows keyboard users to keep the overlay open while navigating
                const activeElement = document.activeElement;
                const isBasketFocused = headerBasket.contains(activeElement) ||
                                       (iconbarHover && iconbarHover.contains(activeElement));

                if (!isBasketFocused) {
                    hideIconbarHover(headerBasket);
                }
            }, delayBasketHover);
        }
    }
}

function eventListenerBasketViewQuantities(basketView, updateTimeout) {
    for (let quantity of basketView.querySelectorAll('.js-itemBasketList .quantity input[type="number"]')) {
        let form = quantity.closest(".js-itemBasketList");
        quantity.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        quantity.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }
}

function eventListenerBasketViewSpDiscounts(basketView, updateTimeout) {
    for (let spDiscount of basketView.querySelectorAll('.js-itemBasketList .spDiscount input[type="number"]')) {
        let form = spDiscount.closest(".js-itemBasketList");
        let max = spDiscount.max;
        let value = spDiscount.value;
        spDiscount.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        spDiscount.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }

}

function eventListenerBasketViewQuantitySpinners(basketView, updateTimeout) {
    for (let spinner of basketView.querySelectorAll('.js-itemBasketList .quantity .js-spinnerUp,.js-itemBasketList .quantity .js-spinnerDown')) {
        let form = spinner.closest(".js-itemBasketList");
        spinner.addEventListener("click", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
    }
}

function updateAllBasketViews(basketView, newBasketView) {
    if (basketView && newBasketView) {
        let oldList = basketView.querySelector('.js-itemBasketList');
        let oldOrderBox = basketView.querySelector('.js-basketOrderBox');
        let oldSummary = basketView.querySelector('.js-basketSummary');

        let newList = newBasketView.querySelector('.js-itemBasketList');
        let newOrderBox = newBasketView.querySelector('.js-basketOrderBox');
        let newSummary = newBasketView.querySelector('.js-basketSummary');

        if (newList) {
            oldList.innerHTML = newList.innerHTML;
            removeLoadingClass(oldList);
            eventListenerBasketViewQuantities(basketView);
            eventListenerBasketViewQuantitySpinners(basketView);
            eventListenerBasketViewSpDiscounts(basketView);
        } else {
            basketView.innerHTML = newBasketView.innerHTML;
            return;
        }

        if (newOrderBox) {
            oldOrderBox.innerHTML = newOrderBox.innerHTML;
            removeLoadingClass(oldOrderBox);
            initToggleSlide(oldOrderBox.querySelectorAll(".js-toggleLinkSlide"));
            initFormSubmitChanges();
        }
        if (newSummary) {
            oldSummary.innerHTML = newSummary.innerHTML;
        }
    }
}

function sendBasketForm(form, basketView) {
    let formData = new FormData(form);
    addLoadingClass(basketView.querySelector('.js-itemBasketList'));
    addLoadingClass(basketView.querySelector('.js-basketOrderBox'));
    fetch(form.action, {
        method: "POST",
        body: formData,
    })
        .then((response) => {
            if (!response.ok) {
                throw "Could not save data";
            }
            return response.text();
        })
        .then((data) => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(data, "text/html");
            updateAllBasketViews(basketView, doc.getElementById('userBasket'));

            // Announce basket update to screen readers
            // Check if there's a flash message in the response
            const flashMessages = doc.querySelectorAll('.flashMessage');
            if (flashMessages.length > 0) {
                flashMessages.forEach(msg => {
                    const messageText = msg.textContent.trim();
                    if (messageText) {
                        announceToScreenReader(messageText);
                    }
                });
            }
        })
        .catch((e) => {
            console.error('Error:', e);
        });
}

export function triggerBasketBtns() {
    let isAddingToBasket = false; // Prevent race conditions from multiple clicks

    // Prevent form submission for all basket-related forms
    // This is critical because buttons have type="submit" which triggers form submission
    // before click handlers can run
    document.addEventListener("submit", function (e) {
        const form = e.target;
        // Check if this is a basket-related form
        if (form.querySelector('.js-addToBasketItemcard') ||
            form.querySelector('.js-addListItemToBasket')) {
            e.preventDefault();
        }
    });

    document.addEventListener("click", function (e) {
        let target = e.target;

        if (target.closest(".js-addListItemToBasket")) {
            target = target.closest(".js-addListItemToBasket");

            // Prevent default form submission - everything should be AJAX
            e.preventDefault();

            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper ? orderButtonWrapper.querySelector('.js-quantity-value') : null;
            let customizableInputValue = form && (form.dataset.customized === '1' || target.classList.contains('orderButton--customizable'));

            if (form && (quantityInput || customizableInputValue)) {
                // For customizable items, open the customization modal
                if (customizableInputValue) {
                    let fn = 'cartCustomize';
                    addLoadingClass(target);
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);

                    XhrService.generalAjaxCall(fn, formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw new Error("Could not save data");
                        }

                        addSuccessClass(target);

                        let existingModal = document.getElementById('modalUserQueue');
                        if (existingModal) {
                            existingModal.remove();
                        }

                        const parser = new DOMParser();
                        const customizeModalParser = parser.parseFromString(response.customizeModal, 'text/html');
                        const customizeModal = customizeModalParser.querySelector('.modal');

                        if(customizeModal){
                            document.body.appendChild(customizeModal);
                            initInputBody(customizeModal.querySelectorAll(".fileBody"));
                            focusInputGroups(customizeModal.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                            showModal(customizeModal);
                            initButtonsForIndividualization();
                        }

                        return response.status;
                    })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('js-addListItemToBasket customization error:', e);
                        console.error('Form action:', form.dataset.action);
                    });
                }
                // For normal items, add to basket
                else if (quantityInput && quantityInput.value > 0) {
                    addLoadingClass(target);
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);
                    XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw new Error("Could not save data");
                        }

                        // Only add success class after confirming the response is valid
                        addSuccessClass(target);

                        const headerBasket = document.querySelector('.js-headerBasket');
                        if (headerBasket) {
                            if (response.headerBasketContent) {
                                var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                                updateHeaderBasket(doc);

                                // Announce to screen readers
                                if (GLOBALS && GLOBALS.tc) {
                                    // Use simple message without placeholders for better screen reader support
                                    let message = GLOBALS.tc.added_to_basket || 'Artikel wurde in den Warenkorb gelegt';
                                    announceToScreenReader(message, 5000); // Longer delay for screen readers
                                }
                            } else {
                                console.warn('js-addListItemToBasket: headerBasketContent is missing in response');
                            }
                        }
                        if (response.tagManager) {
                            appendScriptToDOM(response.tagManager, true);
                        }
                        form.reset();
                        updateItemlistStickyOrderBarCount();
                        return response.status;
                    })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('js-addListItemToBasket error:', e);
                        console.error('Form action:', form.dataset.action);
                    });
                }
            }
        }

        if (target.closest(".js-addToBasketItemcard")) {
            target = target.closest(".js-addToBasketItemcard");

            // Prevent default form submission - everything should be AJAX
            e.preventDefault();

            // Prevent race conditions - ignore clicks while request is in progress
            if (isAddingToBasket) {
                return;
            }

            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper ? orderButtonWrapper.querySelector('.js-quantity-value') : null;
            let customizableInputValue = form.dataset.customized === '1' || target.classList.contains('orderButton--customizable');
            let quantityValue = 0;

            if ((form && quantityInput) || (form && customizableInputValue)) {
                if (quantityInput) {
                    quantityValue = quantityInput.value;
                }
                if (quantityValue > 0 || customizableInputValue) {
                    let fn = 'cart';
                    isAddingToBasket = true;
                    addLoadingClass(target);
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);
                    if (customizableInputValue) {
                        fn = 'cartCustomize';
                    }

                    let crossSellerCheckBoxes = document.querySelectorAll('input[type="checkbox"][name="cross-seller-option"]:checked');
                    if (crossSellerCheckBoxes.length > 0) {
                        let crossSellerValues = Array.from(crossSellerCheckBoxes).map(checkbox => checkbox.value);
                        formData.append("cross_sellers", JSON.stringify(crossSellerValues));
                    }

                    XhrService.generalAjaxCall(fn, formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw new Error("Could not save data");
                        }

                        // Only add success class after confirming the response is valid
                        addSuccessClass(target);
                        if (fn == 'cartCustomize') {
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                existingModal.remove();
                            }

                            const parser = new DOMParser();
                            const customizeModalParser = parser.parseFromString(response.customizeModal, 'text/html');
                            const customizeModal = customizeModalParser.querySelector('.modal');

                            if(customizeModal){
                                document.body.appendChild(customizeModal);
                                initInputBody(customizeModal.querySelectorAll(".fileBody"));
                                focusInputGroups(customizeModal.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                                showModal(customizeModal);
                                initButtonsForIndividualization();
                            }
                        } else {
                            const headerBasket = document.querySelector('.js-headerBasket');
                            if (headerBasket) {
                                if (response.headerBasketContent) {
                                    var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                                    updateHeaderBasket(doc);

                                    // Announce to screen readers
                                    if (GLOBALS && GLOBALS.tc) {
                                        // Use simple message without placeholders for better screen reader support
                                        let message = GLOBALS.tc.added_to_basket || 'Artikel wurde in den Warenkorb gelegt';
                                        announceToScreenReader(message, 5000); // Longer delay for screen readers
                                    }
                                } else {
                                    console.warn('js-addToBasketItemcard: headerBasketContent is missing in response');
                                }
                            }
                            if (response.tagManager) {
                                appendScriptToDOM(response.tagManager, true);
                            }
                            form.reset();
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                closeModal(existingModal);
                            }
                        }

                        isAddingToBasket = false;
                        return response.status;
                    })
                    .catch((e) => {
                        isAddingToBasket = false;
                        addErrorClass(target);
                        console.error('js-addToBasketItemcard error:', e);
                        console.error('Form action:', form.dataset.action);
                    });
                }
            }
        }

        if (target.closest(".js-removeFromBasketHover")) {
            target = target.closest(".js-removeFromBasketHover");

            addLoadingClass(target);
            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('var_code', target.dataset.var_code);
            formData.set('item_key', target.dataset.itemkey);


            XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                addSuccessClass(target);
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                const headerBasket = document.querySelector('.js-headerBasket');
                if (headerBasket && response.headerBasketContent) {
                    var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                    updateHeaderBasket(doc);

                    // Announce to screen readers
                    if (GLOBALS && GLOBALS.tc) {
                        // Use simple message for better screen reader support
                        let message = 'Artikel wurde aus dem Warenkorb entfernt';
                        announceToScreenReader(message, 5000); // Longer delay for screen readers
                    }
                }
                if (response.tagManager) {
                    appendScriptToDOM(response.tagManager, true);
                }
                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });
            e.preventDefault();
        }

        if (target.closest(".js-saveBasketCustomization")) {
            target = target.closest(".js-saveBasketCustomization");
            addLoadingClass(target);

            let form = target.closest("form");
            let formData = new FormData(form);
            formData.set('action', form.dataset.action);

            XhrService.generalAjaxCall('saveCustomization', formData, 'POST', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                let customizationData = response.inputDataArray;
                Object.keys(customizationData).forEach(key => {
                    let cleanKey = key.replace("input", "");
                    let customizationText = document.getElementById(cleanKey);
                    customizationText.innerHTML = customizationData[key];
                });
                form.reset();
                let existingModal = document.getElementById('modalUserQueue');
                if (existingModal) {
                    closeModal(existingModal);
                }
            })
            .catch((e) => {
                addErrorClass(target);
                console.error('Error:', e);
            });

            e.preventDefault();
        }

        if (target.closest(".js-basketEditCustomization")) {
            target = target.closest(".js-basketEditCustomization");
            addLoadingClass(target);

            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('customization_hash', target.dataset.customizationhash);

            XhrService.generalAjaxCall('editCustomization', formData, 'GET', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);

                let itemBasketList = document.getElementById('form_user_basket');
                if (itemBasketList) {
                    let existingModal = document.getElementById('modalUserQueue');
                    if (existingModal) {
                        existingModal.remove();
                    }
                    let customizeModal = response.customizeModal;
                    let newElement = document.createElement('div');
                    newElement.innerHTML = customizeModal;
                    while (newElement.firstChild) {
                        itemBasketList.appendChild(newElement.firstChild);
                    }
                    newElement.remove();
                    initInputBody(document.getElementById("modalUserQueue").querySelectorAll(".fileBody"));
                    focusInputGroups(document.getElementById("modalUserQueue").querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                    showModal(document.getElementById("modalUserQueue"));
                }

                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });

            e.preventDefault();
        }

        if (target.closest(".js-addListItemToBasketAll")) {
            target = target.closest(".js-addListItemToBasketAll");
            let quantityInputs = getAllQuantityInputs();
            let forms = new Set();

            for(let qty of quantityInputs){
                let form = qty.closest("form");
                if(form){
                    forms.add(form);
                }
            }

            if (forms) {
                let formDatas = new FormData();
                for(let form of forms){
                    let qtyInput = form.querySelector('.quantity input[type="number"]');
                    if(qtyInput){
                        if(parseInt(qtyInput.value) > 0){
                            let formData = new FormData(form);
                            for (let pair of formData.entries()) {
                                formDatas.append(pair[0], pair[1]);
                            }
                        }
                    }
                }
                addLoadingClass(target);
                formDatas.set('action', 'shop_add_all_items_to_basket');

                XhrService.generalAjaxCall('cart', formDatas, 'POST', 'json').then(response => {
                    if (!response.status) {
                        throw "Could not save data";
                    }
                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    for(let form of forms){
                        form.reset();
                    }
                    updateItemlistStickyOrderBarCount();
                    addSuccessClass(target);
                    return response.status;
                })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                        console.error(formDatas);
                    });

            }
            e.preventDefault();
        }
    });
}

export function triggerUpdateBasketView() {
    let updateTimeout = false;
    let basketView = document.getElementById("userBasket");
    if (basketView) {
        eventListenerBasketViewQuantities(basketView, updateTimeout);
        eventListenerBasketViewQuantitySpinners(basketView, updateTimeout);
        eventListenerBasketViewSpDiscounts(basketView, updateTimeout);
    }
}